import CodeBlockLowlight from "@tiptap/extension-code-block-lowlight";
import { common, createLowlight } from "lowlight";

export const HighlightedCodeBlock = CodeBlockLowlight.configure({
  lowlight: createLowlight(common),
  HTMLAttributes: {
    spellCheck: "false",
  },
});
